// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Alert } from '@mui/material';
import { AppIcon } from '@shared/ui-kit';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { AccountOpeningButton } from '@shared/advisory/account-workflow/components/account-opening/account-opening-button';
import { useNuvaraInversisBanner } from './use-nuvara-inversis-banner';

export const NuvaraInversisBanner = defineComponent<
  'NuvaraInversisBanner',
  Record<string, never>,
  { canResumeAccountOpening: boolean }
>({
  displayName: 'NuvaraInversisBanner',
  useSetup: useNuvaraInversisBanner,
  View: ({ canResumeAccountOpening }) => (
    <div className="mx-4 my-2 max-w-screen-2xl md:mx-16 md:my-8 2xl:mx-auto 2xl:w-full 2xl:px-16">
      <Alert
        severity="info"
        icon={<AppIcon icon="Info" size="2xl" color="inherit" />}
        classes={{
          root: '!bg-banner-inf-bg !border-l-4 !border-banner-inf-border !rounded-lg',
          icon: '!text-banner-inf-icon',
          message: '!w-full',
        }}
        data-testid="nuvara-inversis-banner"
      >
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <p className="text-lg font-normal !text-subtitle">
              <Translation
                i18nKey="aggregator.nuvara-inversis-banner-message"
                ns="aggregator"
              />
            </p>

            <p
              className="text-lg font-semibold !text-subtitle"
              data-testid="nuvara-inversis-banner-provider"
            >
              <Translation
                i18nKey="aggregator.nuvara-inversis-banner-disclaimer"
                ns="aggregator"
              />
            </p>
          </div>

          <div className="shrink-0">
            <AccountOpeningButton
              canResumeAccountOpening={canResumeAccountOpening}
            />
          </div>
        </div>
      </Alert>
    </div>
  ),
});
